import React, { useState } from "react";
import AdminPageLayout from "../../components/AdminPageLayout";
import { useTheme } from "../../contexts/ThemeContext";
import { EssentialInstrumentTab } from "../../types/essentialInstruments";
import EssentialContractsTab from "./EssentialInstruments/components/EssentialContractsTab";
import EssentialCurrenciesTab from "./EssentialInstruments/components/EssentialCurrenciesTab";
import EssentialOptionContractsTab from "./EssentialInstruments/components/EssentialOptionContractsTab";

const TAB_OPTIONS: { value: EssentialInstrumentTab; label: string }[] = [
  { value: "contracts", label: "Contracts" },
  { value: "options", label: "Option Contracts" },
  { value: "currencies", label: "Currencies" },
];

const EssentialInstrumentsPage: React.FC = () => {
  const { theme } = useTheme();
  const isDarkMode = theme === "dark";
  const [activeTab, setActiveTab] = useState<EssentialInstrumentTab>("contracts");

  return (
    <AdminPageLayout
      title="Essential Instruments"
      description="Manage essential contracts, options, and currencies used for historical data computation"
      hideContentScroll={activeTab === "contracts" || activeTab === "options"}
      headerContent={
        <div className="flex items-center gap-3">
          <label
            className={`text-sm font-medium ${isDarkMode ? "text-rp-grey/70" : "text-gray-700"}`}
          >
            Instrument Type:
          </label>
          <select
            value={activeTab}
            onChange={(e) => setActiveTab(e.target.value as EssentialInstrumentTab)}
            className={`border rounded-md px-3 py-2 text-sm focus:outline-none focus:ring-2 ${
              isDarkMode
                ? "focus:ring-rp-amber bg-rp-surface border-rp-separator text-rp-grey"
                : "focus:ring-blue-500 bg-white border-gray-300 text-gray-900"
            }`}
          >
            {TAB_OPTIONS.map((tab) => (
              <option key={tab.value} value={tab.value}>
                {tab.label}
              </option>
            ))}
          </select>
        </div>
      }
    >
      {activeTab === "contracts" && <EssentialContractsTab />}
      {activeTab === "options" && <EssentialOptionContractsTab />}
      {activeTab === "currencies" && <EssentialCurrenciesTab />}
    </AdminPageLayout>
  );
};

export default EssentialInstrumentsPage;
